/**
 * Column Control
 */
import { Component, registerComponent } from 'js/component.js';
const componentName = 'column-control';

export class ColumnControl extends Component {

    /**
     * Component Setup
     */
    // Elements
    elements = {
        body: document.body
    };

    // Util & State
    animationDisabledClass = 'disable-animations';

    // Remove unnecessary whitespace (so :empty CSS pseudo-class works)
    removeWhitespace() {
        const columnEls = document.querySelectorAll('div[class^="col-desktop-"]');
        for (let i = 0; i < columnEls.length; i += 1) {
            if(columnEls[i].innerHTML.trim().length === 0) columnEls[i].innerText = '';
        }
    }

    /**
     * Initialize Component
     */
    init() {
        this.removeWhitespace();
    }
}

registerComponent(`.${componentName}`, ColumnControl);
